/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardPostWinConfigText
 */
export interface RewardPostWinConfigText {
    /**
     * 
     * @type {string}
     * @memberof RewardPostWinConfigText
     */
    callToAction?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardPostWinConfigText
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof RewardPostWinConfigText
     */
    header: string;
}

/**
 * Check if a given object implements the RewardPostWinConfigText interface.
 */
export function instanceOfRewardPostWinConfigText(value: object): value is RewardPostWinConfigText {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('header' in value) || value['header'] === undefined) return false;
    return true;
}

export function RewardPostWinConfigTextFromJSON(json: any): RewardPostWinConfigText {
    return RewardPostWinConfigTextFromJSONTyped(json, false);
}

export function RewardPostWinConfigTextFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardPostWinConfigText {
    if (json == null) {
        return json;
    }
    return {
        
        'callToAction': json['callToAction'] == null ? undefined : json['callToAction'],
        'description': json['description'],
        'header': json['header'],
    };
}

export function RewardPostWinConfigTextToJSON(value?: RewardPostWinConfigText | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'callToAction': value['callToAction'],
        'description': value['description'],
        'header': value['header'],
    };
}

